module.exports = __webpack_public_path__ + "static/media/JeidaCoverPhoto.0ad5a1f4.jpg";